import { PiClockCountdown, PiProhibit, PiCheckCircle } from 'react-icons/pi';
import { Card, Skeleton } from '@/components/ui';
import { useWorkerProfile } from '@/api/worker';
import styles from './OnboardingPage.module.css';

const STATUS_CONFIG = {
    pending: {
        icon: PiClockCountdown,
        title: 'Tu cuenta esta en revision',
        message: 'Un administrador revisara tu perfil y te asignara las profesiones correspondientes. Recibiras acceso al feed de trabajos una vez aprobado.',
        variant: 'pending' as const,
    },
    suspended: {
        icon: PiProhibit,
        title: 'Cuenta suspendida',
        message: 'Tu cuenta ha sido suspendida. Contacta al administrador para mas informacion.',
        variant: 'suspended' as const,
    },
    approved: {
        icon: PiCheckCircle,
        title: 'Cuenta aprobada!',
        message: 'Ya puedes acceder al feed de trabajos disponibles.',
        variant: 'approved' as const,
    },
};

export function OnboardingPage() {
    const { data: profile, isLoading } = useWorkerProfile();

    if (isLoading) {
        return (
            <div className={styles.container}>
                <Card className={styles.card}>
                    <Skeleton width={56} height={56} variant="rounded" />
                    <Skeleton variant="title" width="60%" height={24} style={{ marginTop: 16 }} />
                    <Skeleton variant="text" width="80%" style={{ marginTop: 8 }} />
                </Card>
            </div>
        );
    }

    const status = (profile?.status || 'pending') as keyof typeof STATUS_CONFIG;
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
    const Icon = config.icon;

    return (
        <div className={styles.container}>
            <Card className={styles.card}>
                <div className={`${styles.iconWrapper} ${styles[config.variant]}`}>
                    <Icon className={styles.icon} />
                </div>
                <h2 className={styles.title}>{config.title}</h2>
                <p className={styles.message}>{config.message}</p>
            </Card>
        </div>
    );
}
